import React, { useState, useRef, useEffect } from "react"
import {Modal, ProgressBar} from 'react-onsenui';
import ZxingQrReader from "./ZxingQrReader";
import styles from './index.module.css'
import { useDeviceNameState } from "../Common/TabPanel/DeviceName/useDeviceName";
import { IconRefresh } from "@tabler/icons-react";
import ValidationResult from "../Common/ValidationResult";
import { useShowValidationResult } from "../Common/ValidationResult/useShowValidationResult";
import TabPanel from "../Common/TabPanel";
import { useScansState } from "../HistoryTabPanel/useScans";
import validateTicket from "../../utils/validateTicket";
import { useEditingDeviceName } from "../Common/TabPanel/DeviceName/useDeviceName";
import usePageVisibility from "../../utils/usePageVisibility";

const ScanTabPanel = () => {

    const [facingMode, setFacingMode] = useState("environment")
    const monitoring = useRef(true)
    const scans = useScansState()
    const [loading, setLoading] = useState(false)
    const deviceName = useDeviceNameState()

    const {setShowValidationResult} = useShowValidationResult()

    const [currentScan, setCurrentScan] = useState()

    const {editingDeviceName} = useEditingDeviceName()

    const [qrReaderActive, setQrReaderActive] = useState(false)

    const pageIsVisible = usePageVisibility()

    useEffect(() => {
        if (pageIsVisible) {
            setQrReaderActive(true)
        } else {
            setQrReaderActive(false)
        }
    }, [pageIsVisible])

    const handleScan = async (data) => {
        if (data) {
            if (monitoring.current) {
                monitoring.current = false
                setLoading(true)

                const scan = await validateTicket(data, deviceName.get())

                setCurrentScan(scan)
                scans.merge([scan])


                setLoading(false)
                setShowValidationResult(true)
            }
        }
    }

    const handleError = err => {
        console.error(err)
    }

    return (
        <TabPanel>

            <div className={`${styles.qrReader} ${editingDeviceName && styles.hidden}`}>
                <ZxingQrReader
                    scanDelay={300}
                    facingMode={facingMode}
                    onResult={async (result) => {
                        await handleScan(result.text)
                    }}
                    onError={handleError}
                    active={qrReaderActive}
                />

                <div className={styles.flipCameraWrapper}>
                    <button
                        className={styles.flipCamera}
                        onClick={() => {
                            setFacingMode(facingMode == "environment" ? "user" : "environment")
                        }
                    }>
                        <IconRefresh size={30} className={styles.cameraRotateIcon}/> 
                    </button>
                </div>
            </div>


            <Modal isOpen={loading}>
                Validating ticket with Starstream's servers...
                <ProgressBar indeterminate/>
            </Modal>

            <ValidationResult
                scan={currentScan}
                onClickNext={() => monitoring.current = true}
            />

        </TabPanel>
    )
}

export default ScanTabPanel
